<template>
  <div class="row">
    <div class="col-md-12">
      <table class="table">
        <thead>
        <tr>
          <th>Lp</th>
          <th>Marka sprzedażowa</th>
          <th>Marka produkcyjna</th>
          <th>PPK</th>
          <th>Wielkość</th>
          <th>Data dostawy</th>
          <th class="text-center">Suma sprzedaży</th>
          <th class="text-center">Zaplanowana nadprodukcja</th>
          <th class="text-center">Zarezerwowane</th>
          <th class="text-center">Magazyn</th>
          <th class="text-center">Wyprodukować</th>
          <th class="text-center">Od aktualizacji</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in overproductionData">
          <td>{{ index + 1 }}</td>
          <td>{{ item.sellBrandName }}</td>
          <td>{{ item.productionBrandName }}</td>
          <td>{{ item.mealName }}</td>
          <td>{{ item.sizeName }}</td>
          <td>{{ item.deliveryDate }}</td>
          <td class="text-center">{{ item.orderQuantity }}</td>
          <td class="text-center"><input
              type="number"
              class="form-control"
              min="0"
              :disabled="item.disabled"
              v-on:keypress="numbersOnly"
              v-model.number="item.overproductionQuantity" @change="save(item)"/></td>
          <td>{{ item.reservedQuantity }}</td>
          <td class="text-center" v-html="warehouse(item)"></td>
          <td class="text-center" v-html="sum(item)"></td>
          <td class="text-center">
            <span v-html="diffProductionList(item)"></span><br/>
            <small v-if="item.productionListDate" style="color: #aaa;">{{ item.productionListDate }}</small>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>
<script>

export default {
  name: 'OverproductionTable',
  props: {
    overproductionData: {
      type: Array,
      required: true,
    }
  },
  methods: {
    warehouse(item) {
      return item.warehouseQuantity + item.overproductionQuantity - item.actualOverproductionQuantity;
    },
    sum(item) {
      return item.orderQuantity + this.warehouse(item) + item.reservedQuantity
    },
    diffProductionList(item) {
      var x = item.orderQuantity + this.warehouse(item) - item.productionListQuantity + item.reservedQuantity
      if (0 < x) {
        return '+' + x;
      } else if (0 === x) {
        return '-';
      }

      return x;
    },
    save(item) {
      this.$emit('save', item)
    },
    numbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    }
  }
}
</script>
